export const createStatusAvatarList = (trackerDS, statuses, setter) => {
    const statusIDCntMap = new Map();

    Object.entries(trackerDS).forEach(([, dp]) => {
        const dpStatusId = dp.status?.status_id || dp.status?.id || null;
        if (dpStatusId) {
            statusIDCntMap.set(dpStatusId, (statusIDCntMap.get(dpStatusId) ?? 0) + 1);
        }
    });

    // sort map in desc order of status count for the player
    const sortedMap = new Map([...statusIDCntMap.entries()].sort((a, b) => b[1] - a[1]));

    if (sortedMap.size === 0) return;

    const statusCntList = [];
    for (const [statusId, statusCnt] of sortedMap) {
        const status = statuses.find(s => s.id === statusId || s.status_id === statusId);
        if (status && statusCnt > 0) {
            statusCntList.push([status, statusCnt]);
        }
    }

    if (statusCntList.length > 0) {
        setter(statusCntList);
    }
};
